import { setPageStateById } from '../PageContext';

export const addWidgetsToRequirements =
  (setState: setPageStateById) =>
  (
    widgets: {
      id: JSX.Element;
      props: {};
    }[],
  ) => {
    setState('ADD_WIDGETS_TO_REQUIREMENTS', (s) => ({
      ...s,
      requiredWidgets: [...s.requiredWidgets, ...widgets],
    }));
  };
